var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"scroll-btn",on:{"click":_vm.backToTop}},[_c('a',{attrs:{"id":"mainScrollBtn"}},[_c('v-icon',{staticClass:"mb-0",attrs:{"large":""}},[_vm._v(_vm._s(_vm.icons.mdiArrowUp))])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }